export const CREATE_CHALLAN = 'CREATE_CHALLAN'
export const PRINT_DATA = 'PRINT_DATA'
export const PRINT_DATA_SUCCESS = 'PRINT_DATA_SUCCESS'
export const CREATE_CHALLAN_SUCCESS = 'CREATE_CHALLAN_SUCCESS'